import React from 'react';

import { BaseIconProps } from '.';

export const Shield = ({ fill }: BaseIconProps) => (
  <path
    d="m 40.474,19.965 -0.724,1.152 -11.075,17.233 -7.327,-6.612 -0.98,-0.896 -1.831,2.005 1.022,0.939 8.434,7.678 1.193,1.067 0.894,-1.365 11.97,-18.6 0.724,-1.152 z M 30.005,2.73 c 2.243,0 4.843,1.51 9.121,3.712 4.065,2.09 9.782,4.655 18.072,6.612 C 56.697,50.072 31.715,63.958 29.962,64.886 29.115,64.476 23.212,61.521 16.707,53.836 9.85,45.737 3.063,32.71 2.812,13.055 11.102,11.098 16.819,8.533 20.884,6.443 25.162,4.24 27.762,2.731 30.005,2.731 Z M 30,0 C 26.655,0 23.832,1.85 19.645,4.01 15.458,6.17 9.838,8.777 1.065,10.708 L 0,10.964 v 1.066 c 0,20.914 7.324,34.89 14.66,43.556 7.334,8.665 14.786,12.115 14.786,12.115 L 30.043,68 30.639,67.701 c 0,0 29.361,-15.187 29.361,-55.67 V 10.964 L 58.935,10.708 C 50.162,8.778 44.542,6.17 40.355,4.01 36.168,1.85 33.345,0 30,0 Z"
    fill={fill}
    transform="matrix(15.882353,0,0,15.882353,63.52941,-2e-6)"
  />
);
